<div class="basket" *ngIf="foods.length > 0 || drinks.length > 0">
  <div class="basket-content">
    <!-- Basket Price -->
    <div class="basket-content-price" *ngIf="total as value">
      <ng-container *ngIf="value | priceSeparator as separated">
        <span class="basket-content-price__whole">{{ separated.whole }}</span
        ><span class="basket-content-price__separator">{{ separated.separator }}</span
        ><span class="basket-content-price__fraction">{{ separated.fraction }}</span>
        <span class="basket-content-price__currency">{{ locale?.currency }}</span>
      </ng-container>
    </div>
    <!-- Foods & Drinks -->
    <div class="basket-content__items">
      <span *ngIf="foodsCount">
        {{ foodsCount }} {{ (foodsCount === 1 ? 'food' : 'foods') | translate }}
      </span>
      <span *ngIf="foodsCount && drinksCount">{{ 'and' | translate }}</span>
      <span *ngIf="drinksCount">
        {{ drinksCount }} {{ (drinksCount === 1 ? 'drink' : 'drinks') | translate }}
      </span>
    </div>
  </div>

  <div class="basket-button" (click)="onBasketClicked(); $event.stopPropagation()">
    <div class="basket-button__content">
      {{ 'basket' | translate }}
      <mat-icon class="basket-button__icon">restaurant</mat-icon>
    </div>
  </div>
</div>